import { useState, useEffect, Component, useLayoutEffect } from 'react';
import NumberFormat from 'react-number-format';
//import axios from "axios";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ProductFilter } from '../ProductFilter.js';
import { useSelector, useDispatch } from 'react-redux';
import {
  actualizaFilter,
  actualizaGroupSelect,
} from '../../../Slicersreducers.js';
import { CardBody, Row, CardTitle } from 'reactstrap';
import React from 'react';

export const Product = React.memo((props) => {
  const groupSelect = useSelector((state) => state.miga.GroupSelect);
  const dispatch = useDispatch();
  const listOcultarFilter = useSelector((state) => state.miga.ocultarFilter);

  const handleFilter = () => {
    let listOcultarFilter = [false, false, false];

    for (let i = 0; i < 3; i++) {
      if (i === props.index) {
        listOcultarFilter[i] = true;
      } else {
        listOcultarFilter[i] = false;
      }
    }
    dispatch(actualizaFilter(listOcultarFilter));
  };

  let color = 'white';
  return (
    <div
      class="card-carousel"
      style={groupSelect[props.indextar] ? { border: '2px solid #28d239' } : {}}
    >
      {' '}
      {/*Esto se debe verificar, para ver el active*/}
      {props.ocultarFiltro ? (
        <ProductFilter
          product={props.data.title}
          movements={props.data.listMovements}
          handleMovements={props.handleMovements}
          deleteTimeAlert={props.deleteTimeAlert}
        />
      ) : (
        <CardBody>
          <Row>
            <div className="col">
              <CardTitle
                tag="h4"
                className="text-uppercase mb-1 font-weight-bold text-green"
                style={{ paddingBottom: '20px' }}
              >
                {props.data.title}
              </CardTitle>

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <span className="text-nowrap text-medium-grey  h4">
                    Total de Productos:
                  </span>
                  <span className="text-nowrap text-medium-grey  h4">
                    {props.data.totalProductos}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <span className="text-nowrap text-medium-grey  h4">
                    Valor Total:
                  </span>
                  <span className="text-nowrap text-medium-grey  h4">
                    <NumberFormat
                      value={props.data.totalValue}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                    ></NumberFormat>
                  </span>
                </div>
                <div />
              </div>
            </div>
          </Row>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'end',
              marginTop: '5px',
            }}
          >
            <button
              className="btn btn-success"
              onClick={() => handleFilter()}
              style={{ width: '40%' }}
            >
              Filtrar
            </button>
          </div>
        </CardBody>
      )}
    </div>
  );
});
